import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class ViewApplicationLocationBpamsConstants {
    static STEP_TITLE = "Location";
    static ZONE_LABEL = "Current Property Zoning";
    static ADD_ZONE_LABEL = "Add zone";
    static MISSING_ZONE_LABEL = "Missing zone(s):";
    static MISSING_ZONE_LABEL_EMAIL = " - Email sent to Administrator";
    static MISSING_ZONE_LABEL_EMAIL_FAILED = "Failed to send missing lookups for zones email to module administrator";
    static OWNER_LABEL = "Owners";
    static REMOVE_PROPERTY_LABEL = "Remove property";
    static DESCRIPTION_LABEL_1 = "Search the map to find the property for which you are lodging an application, using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct property and click on the property. Click on 'add property' in the window that appears on the map after you selected the property.";
    static DESCRIPTION_LABEL_3 = "The property will be added and the fields must be completed for the property. Please note that multiple properties may be added.";
    static DESCRIPTION_LABEL_4 = "Please note that the zoning here is the current zoning of the property. Please note that an owner should be added for each property (this is linked to the property and the application).";
    static PROPERTY_REQUIRED = "Please select a property before continuing with the create application process";
    static MISSING_ZONE_EMAIL_SUBJECT = "Missing property zone(s) - add to lookups";
    static MISSING_ZONE_EMAIL_CONTENT = "Please add the following property zone(s) to the lookups:";
    static PROPERTY_APPLICATION_DETAILS_LABEL = "Property application details";
    static BUILDING_DETAILS_LABEL = "Building details";
    static MAIN_BUILDING_LABEL = "Main building";
    static OUT_BUILDING_LABEL = "Outbuilding / additional building";
    static TOTAL_LABEL = "Total";
    static BUILDING_TOTAL_LABEL = "Building Total";
    static STOEP_LABEL = "Patios / stoeps";
    static MISCELLANEOUS_LABEL = "Miscellaneous";
    static ERF_NO_CONTROL = "erfNo";
    static SUBDIVISION_CONTROL = "subdivision";
    static FARM_NO_CONTROL = "farmNo";
    static ALLOTMENT_CONTROL = "allotment";
    static SG_CODE_CONTROL = "sgCode";
    static ADDRESS_CONTROL = "address";
    static ERF_SIZE_CONTROL = "erfSize";
    static TITLE_DEED_CONTROL = "titleDeed";
    static ZONE_CONTROL = "zones";
    static OWNER_CONTROL = "owners";
    static PROPERTIES_CONTROL = "properties";
    static PROPERTY_DESCRIPTION_CONTROL = "propertyDescription";
    static TITLE_DEED_RESTRICTION_CONTROL = "applicationRestrictions";
    static EXTERNAL_WALLS_CONTROL = "externalWalls";
    static INTERNAL_WALLS_CONTROL = "internalWalls";
    static ROOFING_CONTROL = "roofing";
    static NUMBER_OF_HOUSES_UNITS_CONTROL = "numberOfHouses";
    static TOTAL_EXISTING_CONTROL = "totalExisting";
    static TOTAL_ADDED_CONTROL = "totalAdded";
    static TOTAL_FLOOR_AREA_CONTROL = "totalFloorArea";
    // patio
    static COVERED_EXISTING_CONTROL = "patioCoveredExisting";
    static COVERED_ADDED_CONTROL = "patioCoveredAdded";
    static OPEN_EXISTING_CONTROL = "patioOpenExisting";
    static OPEN_ADDED_CONTROL = "patioOpenAdded";
    static TOTAL_EXISTING_PATIO_CONTROL = "totalExistingPatio";
    static TOTAL_ADDED_PATIO_CONTROL = "totalAddedPatio";
    // misc
    static POOL_CONTROL = "pool";
    static BOUNDARY_WALL_HEIGHT_CONTROL = "boundaryWallHeight";
    static BOUNDARY_WALL_RUNNING_CONTROL = "boundaryWallRunning";
    static COVERAGE_CONTROL = "coverage";
    static BULK_CALCULATION_CONTROL = "bulkCalculation";
    // TODO check:
    static FLOOR_CONTROL_NAME = "floor";
    static EXISTING_SIZE_CONTROL_NAME = "existingSize";
    static ADDED_SIZE_CONTROL_NAME = "addedSize";
    static ERF_NO_TEXT_PLACEHOLDER = "Erf no";
    static SUBDIVISION_TEXT_PLACEHOLDER = "Subdivision / portion number";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static ALLOTMENT_TEXT_PLACEHOLDER = "Allotment / suburb";
    static SG_CODE_TEXT_PLACEHOLDER = "SG Code";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static ERF_SIZE_TEXT_PLACEHOLDER = "Erf size";
    static TITLE_DEED_TEXT_PLACEHOLDER = "Title deed";
    static PROPERTY_DESCRIPTION_LABEL = "Property description";
    static TITLE_DEED_RESTRICTION_LABEL = "Title deed restrictions";
    static EXTERNAL_WALLS_LABEL = "External walls";
    static INTERNAL_WALLS_LABEL = "Internal walls";
    static ROOFING_LABEL = "Roofing";
    static NUMBER_OF_HOUSES_UNITS_LABEL = "Number of houses / units";
    static TOTAL_EXISTING_LABEL = "Total existing (m²)";
    static TOTAL_ADDED_LABEL = "Total added (m²)";
    static TOTAL_FLOOR_AREA_LABEL = "Total floor area (m²)";
    // patio
    static COVERED_EXISTING_LABEL = "Covered - existing (m²)";
    static COVERED_ADDED_LABEL = "Covered - added (m²)";
    static OPEN_EXISTING_LABEL = "Open - existing (m²)";
    static OPEN_ADDED_LABEL = "Open - added (m²)";
    static TOTAL_EXISTING_PATIO_LABEL = "Total - existing (m²)";
    static TOTAL_ADDED_PATIO_LABEL = "Total - added (m²)";
    // misc
    static POOL_LABEL = "Pool (m2)";
    static BOUNDARY_WALL_HEIGHT_LABEL = "Boundary wall height (m)";
    static BOUNDARY_WALL_RUNNING_LABEL = "Boundary wall running (m)";
    static COVERAGE_LABEL = "Coverage (%)";
    static BULK_CALCULATION_LABEL = "Bulk calculation (FAR) (%)";
    static CALCULATIONS_LABEL = "Calculations";
    // TODO: Check
    static REMOVE_DIALOG_TEXT = `${SharedConstants.REMOVE_TITLE} building`;
    static FLOOR_LABEL = "Floor";
    static EXISTING_SIZE_LABEL = "Existing Size (m²)";
    static ADDED_SIZE_LABEL = "Added Size (m²)";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static LAYER_REF = "Building plans graphics";
    static INVALID_OWNER_ATTRIBUTE = "Some owner attribute(s) is missing on the property owner layer. Please contact your systems administrator.";
    static INVALID_ZONING_ATTRIBUTE = "Zoning attribute is missing on the property zoning layer. Please contact your systems administrator.";
    static ZONING_NOT_FOUND = "The found zone ({0}) has not been configured in the lookups. Please contact your systems administrator.";
    static VALIDATION_MESSAGES = {
        erfNo: {
            required: `Erf no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        allotment: {
            required: `Allotment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        sgCode: {
            required: `SG code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        address: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        erfSize: {
            required: `Erf size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        titleDeed: {
            required: `Title deed ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        zone: {
            required: `Zone ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
